import type { TFunction } from 'i18next';
import { z } from 'zod';

export const LICENSING_AUTHORITY_MAX_LENGTH = 20;

export const LicenseSchema = (t?: TFunction) => {
	const maxLengthMsg = t
		? t('Must be {{max}} characters or less', {
				max: LICENSING_AUTHORITY_MAX_LENGTH
			})
		: `Must be ${LICENSING_AUTHORITY_MAX_LENGTH} characters or less`;

	return z.object({
		__typename: z.literal('License').optional(),

		// Editable Fields
		licenseNumber_V: z.string().nullish(), // ID
		typeValue_VId: z
			.string()
			.max(LICENSING_AUTHORITY_MAX_LENGTH, { message: maxLengthMsg })
			.nullish(), // Licensing Authority (Editable)
		expirationDate_V: z.string().nullish(),
		licenseStatus_V: z.string().nullish(),

		// Read-Only / Static Fields
		bestStateLicense_V: z.boolean().nullish(),
		body_V: z.string().nullish(),
		collabAgreeRequired_V: z.string().nullish(),
		comprehensivePrescriptiveAuthority_V: z.string().nullish(),
		comprehensiveSampleEligibility_V: z.string().nullish(),
		ctrlSubstancePrescriptive_V: z.string().nullish(),
		ctrlSubstanceSample_V: z.string().nullish(),
		deaBusinessActivityCode_V: z.string().nullish(),
		deaPaymentIndicator_V: z.string().nullish(),
		drugSchedule_V: z.string().nullish(),
		gracePeriod_V: z.string().nullish(),
		licenseCertification_V: z.string().nullish(),
		licenseDegree_V: z.string().nullish(),
		licenseEligibility_V: z.string().nullish(),
		licenseStatusCondition_V: z.string().nullish(),
		licenseSubtype_V: z.string().nullish(),
		rxaEligible_V: z.string().nullish(),
		sourceAddress_V: z.string().nullish(),
		type_V: z.string().nullish(), // License Type

		typeValue_V: z.string().nullish(),
		vid_V: z.string().nullish()
	});
};

export const AddLicenseSchema = (t?: TFunction) => {
	const requiredMsg = t
		? t('This field is required')
		: 'This field is required';

	return LicenseSchema(t).extend({
		licenseNumber_V: z
			.string({ error: requiredMsg })
			.trim()
			.min(1, { message: requiredMsg })
	});
};

export const LicensesSectionSchema = (t?: TFunction) => {
	return z.object({
		licenses: z.array(LicenseSchema(t)).nullish()
	});
};
